<template>
  <div class="page" :class="$route.meta.background === 'white' && 'u__background--white'">
    <div class="page-header">
      <Content>
        <h1>{{ $route.meta.title }}</h1>
      </Content>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  }
};
</script>

<style lang="scss" scoped>
.page {
  flex: 1;
}

.page-header {
  background: $primary;
  padding: $padding-large 0;

  h1 {
    font-size: 3rem;
    font-weight: 400;
    color: $white;
  }

  p {
    color: $white;
  }

  @media(max-width: $width-sm) {
    padding: $padding 0;
  }
}
</style>
